import { Component, Output, TemplateRef, ViewChild, EventEmitter } from '@angular/core';
import { DropdownPanel } from './dropdown-panel';

@Component({
	selector: 'vb-lxp-dropdown',
	templateUrl: './vb-lxp-dropdown.component.html',
	styleUrl: './vb-lxp-dropdown-component.css',
})
export class VbLxpDropdownComponent implements DropdownPanel {
	@ViewChild(TemplateRef) templateRef: TemplateRef<any>;
	@Output() closed = new EventEmitter<void>();

	constructor() {}
}
